export const DEFAULT_FIXED_WIDTH = 204;
export const DEFAULT_ROW_CELL_WIDTH = 84;
export const DEFAULT_CELL_HEIGHT = 48;
export const DEFAULT_HEAD_CELL_HEIGHT = 54;
